var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomDropdown',{attrs:{"header":_vm.hasHeader ? 'Country' : null,"placeholder":"Select an option","items":[
    { label: 'USA', value: 'USA' },
    { label: 'Canada', value: 'CAN' },
  ],"value":_vm.value},on:{"input":(val) => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }